module.exports = __webpack_public_path__ + "img/Vector1.eaa67248.svg";